import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=d40f13b2&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=d40f13b2&prod&scoped=true&lang=scss"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=d40f13b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40f13b2",
  null
  
)

export default component.exports